import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
export const config = {
    value: 'tableReload',
    position: ALL_BUTTON_POSITION_LIST,
    action: (arg) => {
        const { buttonConfig, _context } = arg || {};
        const { options = {} } = buttonConfig;
        const { _bindTable, keepPagination, refreshExceptPaging } = options;
        function reloadOneTable(id) {
            if (typeof id === 'string') {
                const table = _context.$(id);
                if (keepPagination === true && refreshExceptPaging === true) {
                    table?.refreshExceptPaging()?.();
                }
                else if (keepPagination === true) {
                    table?.tableLoad()?.();
                }
                else {
                    table?.load?.();
                }
            }
        }
        if (_bindTable && _context) {
            if (Array.isArray(_bindTable)) {
                _bindTable.forEach((item) => {
                    reloadOneTable(item);
                });
            }
            else {
                reloadOneTable(_bindTable);
            }
        }
    },
};
